import { render, staticRenderFns } from "./TicketInfo.vue?vue&type=template&id=42513823&scoped=true&"
import script from "./TicketInfo.vue?vue&type=script&lang=js&"
export * from "./TicketInfo.vue?vue&type=script&lang=js&"
import style0 from "./TicketInfo.vue?vue&type=style&index=0&id=42513823&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42513823",
  null
  
)

export default component.exports